import { styled } from "@mui/material";
import type { UseInfiniteQueryResult } from "@tanstack/react-query";

import { Spinner } from "@citrine/atoms/loading";

import * as sx from "./library.sx";
const GAP_SPACING = 4;

export const VirtualFooter = ({
  context,
}: {
  context?: UseInfiniteQueryResult;
}) =>
  context?.hasNextPage || context?.isFetchingNextPage ? (
    <sx.SpinnerWrapper>
      <Spinner />
    </sx.SpinnerWrapper>
  ) : null;

export const VirtualItem = styled("div")(({ theme }) => ({
  paddingTop: theme.spacing(GAP_SPACING),
}));
